import { render, staticRenderFns } from "./DemoBar.vue?vue&type=template&id=0537df64&scoped=true"
import script from "./DemoBar.vue?vue&type=script&lang=js"
export * from "./DemoBar.vue?vue&type=script&lang=js"
import style0 from "./DemoBar.vue?vue&type=style&index=0&id=0537df64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0537df64",
  null
  
)

export default component.exports